/**
 * Controller: layoutsTicketsRemoveModal
 */
angular.module('acme.view.application.layouts.tickets.removeModal.controllers', [
  'ui.bootstrap'
])
.controller('LayoutsTicketsRemoveModalController', ['$scope', '$uibModalInstance', 'item', 'events', 'allow', function($scope, $uibModalInstance, item, events, allow) {

  $scope.layoutsTicketsRemoveModal = {

    name: item.name,
    events: events.data.payload || [],
    allow: allow,

    confirm: function () {
      $uibModalInstance.close(true);
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    }

  };

}]);